import { CountdownTimerApiResponse, CountdownTimerLink } from '../types/WhatsAppSettings'


export const normalizeCountdownTimer = (
    timer?: CountdownTimerApiResponse | null
  ): CountdownTimerLink | null => {
    if (!timer) {
      return null
    }
  
    const rawLinkId = timer.linkId ?? timer._id
    if (rawLinkId === undefined || rawLinkId === null || `${rawLinkId}`.trim() === '') {
      return null
    }
  
    return {
      linkId: String(rawLinkId),
      name: timer.name ?? '',
      trackingLink: timer.trackingLink ?? '',
      timerType: timer.timerType,
    }
}
  
export const toNormalizedIdSet = (ids: Array<string | number>): string[] => {
    return Array.from(
        new Set(
        ids
            .map((id) => String(id))
            .map((id) => id.trim())
            .filter((id) => id !== '')
        )
    )
}